var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"vm.sideTab.rentalItems = !vm.sideTab.rentalItems\">Close</md-button></div><div layout=\"row\"><div><h3>Add Rental Item to Contract</h3><br/><label>By Name </label><input ng-model=\"vm.byNameEntry\" class=\"form-control\"/><br/><md-button ng-click=\"vm.runSearch({'schema': '/events/rentalitems', 'model': 'addableRentalItems'}, vm.byNameEntry)\" class=\"md-raised\">Search</md-button><div ng-repeat=\"item in vm.addableRentalItems\" style=\"border: solid black 1px; background-color: white\" class=\"itemCard\"><a href=\"\" ng-click=\"vm.addRentalItem(item)\"> <span class=\"glyphicon glyphicon-circle-arrow-left\"> </span></a><span title=\"{{item.description}}\">&nbsp; {{item.name}}</span></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/contracts/tabs/addRentalItem.jade
// module id = 279
// module chunks = 0